// extracted by mini-css-extract-plugin
export default {"recentStatsContainer":"styles_recentStatsContainer__+Iu13","recentStatsContainerInner":"styles_recentStatsContainerInner__B5RI3"};